import angular from 'angular';
import bootstrap from 'angular-ui-bootstrap';
import i18n from '../i18n';

import tooltip from './tooltip-directive';

/**
 * @ngdoc module
 * @name akamai.components.tooltip
 * @guideline https://design.akamai.com/components/tooltip/
 * @description Tooltips show short help text on hover of a targeted UI element.
 */
module.exports = angular.module('akamai.components.tooltip', [
  bootstrap,
  i18n.name
])
/**
 * @ngdoc directive
 *
 * @name akamTooltip
 *
 * @description Creates a basic themed tooltip for an element
 *
 * @restrict A
 *
 * @param {string} akam-tooltip tooltip text content.
 *
 * @param {string} [tooltip-placement=bottom] Where the popover appears
 * [bottom-left, bottom, bottom-right, top-left, top, top-right]
 *
 * @param {boolean} [tooltip-append-to-body=false] If true, the tooltip will be appended to the
 * body. Use this when using a tooltip in a container that is set to `overflow: hidden`.
 * *
 * @param {*} [arrow] If present an arrow will be shown pointing to the reference element
 *
 */
  .directive('akamTooltip', tooltip);